/* eslint-disable no-unused-vars */
import { useEffect, useState, useRef } from 'react';
import * as S from './SearchBar.styled';
import { Search, DropDownList_v2, Buttons } from 'components';
import { useSignal } from '@preact/signals-react';
import { Search as SmallSearchIcon } from 'assets/icons';
import { saveCampaignServiceAPI } from 'services/saveCampaign.service';
import { FilterBnt_v2 } from './filterBtn/FilterBnt_v2';

export const SearchBar = ({ selectedCampaigns$, selectedStatusFilter$ }) => {
  const searchValue$ = useSignal('');
  const showDropDown$ = useSignal(false);
  const searchRef = useRef(null);

  return (
    <S.Container>
      <S.SearchBox>
        <Search
          deleteIconName='manageCampaignDeleteSearch'
          onFocus={() => {
            showDropDown$.value = true;
          }}
          ref={searchRef}
          id='manageCampaignSearch'
          onChange={(e) => (searchValue$.value = e.target.value)}
          value={searchValue$?.value}
          placeholder='Search Campaign'
          rightIconOnClick={() => (searchValue$.value = '')}
          Icon={SmallSearchIcon}
        />
        {showDropDown$.value ? (
          <DropDownList_v2
            searchRef={searchRef}
            showDropDown$={showDropDown$}
            searchValue$={searchValue$}
            selectedCampaigns$={selectedCampaigns$}
          />
        ) : null}
      </S.SearchBox>
      <FilterBnt_v2 selectedStatusFilter$={selectedStatusFilter$} />
      <Buttons.TertiarySmall>Export</Buttons.TertiarySmall>
    </S.Container>
  );
};
